"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypographyComponent = Typography;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledTypography = _interopRequireDefault(require("./styled-typography"));
var _excluded = ["children", "dataTestId", "tag", "type"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var propTypes = {
  children: _propTypes["default"].node,
  color: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
    xxs: _propTypes["default"].string,
    xs: _propTypes["default"].string,
    s: _propTypes["default"].string,
    m: _propTypes["default"].string,
    l: _propTypes["default"].string,
    xl: _propTypes["default"].string,
    xxl: _propTypes["default"].string
  })]),
  tag: _propTypes["default"].string,
  type: _propTypes["default"].string
};
var defaultProps = {
  children: undefined,
  color: undefined,
  dataTestId: null,
  size: '7',
  tag: undefined,
  type: 'heading'
};
function Typography(_ref) {
  var children = _ref.children,
    dataTestId = _ref.dataTestId,
    tag = _ref.tag,
    type = _ref.type,
    props = _objectWithoutProperties(_ref, _excluded);
  var defaultTags = {
    display: 'h1',
    heading: 'h1',
    paragraph: 'p'
  };
  return /*#__PURE__*/_react["default"].createElement(_styledTypography["default"], _extends({
    className: "fuse-typography-element",
    "data-testid": dataTestId,
    as: tag || defaultTags[type],
    type: type
  }, props), children);
}
Typography.propTypes = propTypes;
Typography.defaultProps = defaultProps;
var _default = exports["default"] = Typography;